import timeSelections from "./components/scheduling/time-selections";

export default {
  application: {
    attachments: [],
    competencies: [],
    links: [],
    additionalFieldResponses: [],
  },

  candidate: {
    attachments: [],
    competencies: [],
    links: [],
  },

  chosenInterview: {},

  comment: {
    comment: '',
  },

  company: {
    photo: null,
    logo: null,
    language: null,
    name: '',
    slug: '',
    careersSlogan: '',
    competencyNames: [],
    features: {},
    branding: {},
    emailReplyTo: {
      name: '',
      email: '',
    },
  },

  previewCandidate: {
    name: '',
    phone: '',
    email: '',
    agreeTOS: false,
    link: '',
    city: '',
    attachments: [],
    additionalFieldResponses: [],
    atsCandidateId: '',
  },

  interview: {
    photo: null,
    logo: null,
    title: '',
    formSetup: {
      name: { visible: true, required: true },
      email: { visible: true, required: true },
      phoneNumber: {},
      city: {},
      attachments: {},
      links: {},
    },
    emailReplyTo: {
      email: '',
      name: '',
    },
    questions: [],
    competencyNames: [],
    chosenCandidates: [],
    additionalFormFields: [],
  },

  interviewAdd: {
    attachToJobAd: null,
    filter: '',
    id: null,
  },

  interviewInvite: {
    addresses: [],
    subject: '',
    message: '',
    name: '',
    endTime: '',
  },

  introduce: {
    emails: [],
    subject: '',
    message: '',
    name: '',
    informations: [],
  },

  invitationMessage: {
    subject: '',
    message: '',
    name: '',
    language: '',
    templateName: '',
  },

  emailTemplate: {
    subject: '',
    message: '',
    name: '',
    language: '',
    templateName: '',
  },

  jobAd: {
    draft: false,
    id: null,
    photo: null,
    logo: null,
    title: '',
    description: '',
    competencyNames: [],
    additionalFormFields: [],
    company: {},
    location: '',
    formSetup: {
      name: { visible: true, required: true },
      email: { visible: true, required: true },
      phoneNumber: {},
      city: {},
      coverLetter: {},
      attachments: {},
      links: {},
      questions: {},
    },
    video: null,
    questions: [],
    jobOpenings: [],
    listings: [],
  },

  schedulingLive: {
    interviewers: [],
    candidates: [],
    title: '',
    message: {
      subject: '',
      body: '',
      greeting: '',
      name: '',
    },
    language: '',
    scheduling: {
      timeSelections: {},
      selectedTimeSlots: [],
    },
  },

  live: {
    startTime: '',
    interviewers: [],
    candidates: [],
    title: '',
    messageTitle: '',
    message: '',
    language: '',
  },

  login: {
    email: '',
    password: '',
  },

  register: {
    email: '',
  },

  forgotPassword: {
    email: '',
  },

  changePassword: {
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
  },

  question: {
    textQuestion: '',
  },

  search: {
    query: '',
    results: {},
  },

  hashtags: {
    tag: '',
    tags: [],
  },

  showInvitationModal: false,
  singleApplication: {},

  team: {
    admins: [],
    inputValue: '',
  },

  emailReplyTo: {
    name: '',
    email: '',
  },

  videos: {
    ids: {},
  },

  usersAdd: {
    emails: [],
    language: '',
    permissions: {
      editUsers: false,
      account: false,
      billing: false,
      seeAllPositions: false,
      createJobPositions: false,
      createInterviews: false,
      reporting: false,
      default: true,
    },
  },

  companyDefaultPermissionsEdit: {
    editUsers: false,
    account: false,
    billing: false,
    seeAllPositions: false,
    createJobPositions: false,
    createInterviews: false,
    reporting: false,
  },

  usersPermissionsEditMatrix: {
    users: [],
    hasChanged: false,
  },

  user: {
    excludeFrom: [],
  },

  account: {
    name: '',
    signature: '',
  },

  SsoLogin: {
    email: '',
  },
}
